import React, { useState } from 'react';
import { stringsHelp } from '../helpers';

export default function HiddenText(props) {
  const originalDocument = (`${props.children}`) || '';
  const type = props.type || 'cpf';
  const maskedDocument = (() => {
    if (type === 'cpf') return stringsHelp.maskCPF(originalDocument);
    return [...originalDocument].reduce(() => '*').join('');
  })();
  const [visible, setVisible] = useState(false);

  return (
    <a
      href="#hide"
      title={visible ? 'Clique para ocultar' : 'Clique para exibir'}
      className="hidden-text"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setVisible((current) => !current);
      }}
    >
      {visible ? originalDocument : maskedDocument}
    </a>
  );
}